import { render, staticRenderFns } from "./PurchaseCommandItemsTable.vue?vue&type=template&id=965b8a90&"
import script from "./PurchaseCommandItemsTable.vue?vue&type=script&lang=ts&"
export * from "./PurchaseCommandItemsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports